import type { FunctionComponent } from 'react';
import { Link, useLocation } from 'react-router';

import { Button } from '~/ui/core/button/Button';
import { theme } from '~/ui/theme/cobrainer-theme';

import type { SideDrawerLinkProperties } from '../navigation-menu-list-item';
import { useNavigationMenu } from './NavigationMenuContext';

export const SideDrawerLinkV2: FunctionComponent<SideDrawerLinkProperties> = (props) => {
    const { isExpanded, shouldContentOverflow } = useNavigationMenu();
    const { externalUrl, label, NewIcon, onRouteChange, path } = props;
    const pathname = useLocation().pathname;
    const isActive = pathname === path || pathname.startsWith(`${path}/`);
    const shouldShowExpandedLayout = isExpanded || shouldContentOverflow;

    const commonClassName =
        'w-full justify-start overflow-hidden p-l! text-left focus-visible:outline focus-visible:outline-1 focus-visible:outline-orange-800';
    const content = (
        <>
            <div className={`flex items-center ${isActive ? 'text-orange-800' : 'text-gray-600'}`}>
                <NewIcon size={theme.typography.body.M.regular.fontSize} />
            </div>
            <span
                className={`flex flex-1 min-w-0 whitespace-nowrap text-sm font-medium leading-none transition-opacity duration-[400ms] ease-[cubic-bezier(0.16,1,0.3,1)] ${isExpanded ? 'opacity-100' : 'opacity-0'} ${isActive ? 'text-orange-800' : 'text-gray-800'}`}
            >
                {label}
            </span>
        </>
    );

    if (externalUrl) {
        return (
            <Button
                className={commonClassName}
                iconOnly={!shouldShowExpandedLayout}
                isActive={isActive}
                variant="tertiary"
                onClick={() => {
                    window.open(path, '_blank');
                    onRouteChange?.();
                }}
            >
                {content}
            </Button>
        );
    }

    return (
        <Button
            as={Link}
            className={commonClassName}
            iconOnly={!shouldShowExpandedLayout}
            isActive={isActive}
            to={path}
            variant="tertiary"
            onClick={onRouteChange}
        >
            {content}
        </Button>
    );
};
